import { convertPhoneNumber } from './utils'

const isEmptyObject = (value) =>
	value &&
	typeof value === 'object' &&
	!Array.isArray(value) &&
	Object.keys(value).length === 0

const compactConditions = (conditions) =>
	conditions.filter((condition) => condition && !isEmptyObject(condition))

const mergeUserPageConditions = (conditions) => {
	const resolvedConditions = compactConditions(conditions)

	if (resolvedConditions.length === 0) {
		return {}
	}

	if (resolvedConditions.length === 1) {
		return resolvedConditions[0]
	}

	return { $and: resolvedConditions }
}

export const filterUserPageList = (datas, baseFilter = {}) => {
	let searchFilter = {}
	let filter = { ...baseFilter }
	if (datas?.value) {
		if (datas?.field === 'phone' && datas?.value?.startsWith('0')) {
			const phones = convertPhoneNumber(datas?.value)
			searchFilter = {
				$or: [
					...phones?.map((phone) => ({
						[datas?.field]: { $iLike: `%${String(phone).trim()}%` },
					})),
				],
			}
		} else if (datas?.field === 'old_name') {
			searchFilter = {
				[datas?.field]: `${String(datas?.value).trim()}`,
			}
		} else if (
			datas?.field === 'country' ||
			datas?.field === 'province'
		) {
			searchFilter = {
				[datas?.field]: {
					$iLike: String(datas?.value).trim(),
				},
			}
		} else {
			searchFilter = {
				[datas?.field]: { $iLike: `%${String(datas?.value).trim()}%` },
			}
		}
	}
	if (datas?.deleted_at) {
		filter = { ...filter, deleted_at: datas.deleted_at }
	}
	if (datas?.blocked_at === 'BLOCKED') {
		filter = { ...filter, blocked_at: { $ne: null } }
	} else if (datas?.blocked_at === 'UNBLOCKED') {
		filter = { ...filter, blocked_at: null }
	}
	return mergeUserPageConditions([searchFilter, filter])
}
export const filterNormal = (datas) => {
	let filter = {}
	if (datas?.value) {
		filter = {
			...filter,
			[datas?.field]: String(datas?.value).trim(),
		}
	}
	return filter
}
export const filterNormalIlike = (datas) => {
	let filter = {}
	if (datas?.value) {
		filter = {
			...filter,
			[datas?.field]: { $iLike: `%${String(datas?.value).trim()}%` },
		}
	}
	return filter
}
export const filterProvince = (datas) => {
	let filter = {}
	if (datas?.value) {
		filter = {
			...filter,
			[datas?.field]: String(datas?.value).trim(),
		}
	}
	if (typeof datas?.minValue === 'number') {
		filter = {
			...filter,
			min: datas?.minValue,
		}
	}
	if (typeof datas?.maxValue === 'number') {
		filter = {
			...filter,
			max: datas?.maxValue,
		}
	}

	return filter
}
